import { ObjectConfigurationContext } from './types';

export const hasMoreRetries = (context: ObjectConfigurationContext) =>
  context.retries! < context.maxRetries!;

export const canSaveCustomObject = (context: ObjectConfigurationContext) =>
  context.selectedObject && context.selectedAttribute;

export const canSelectAttribute = (context: ObjectConfigurationContext) =>
  !!context.selectedObject;
